import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ current, max, label, showPercentage = true }) => {
  const isUnlimited = max === 0;
  const percentage = isUnlimited ? 0 : Math.min((current / max) * 100, 100);

  const getBarClass = () => {
    if (isUnlimited) return '';
    if (percentage >= 100) return 'danger';
    if (percentage >= 80) return 'warning';
    return '';
  };

  const formatDisplay = () => {
    if (isUnlimited) {
      return `${current.toLocaleString()} (Ilimitado)`;
    }
    return `${current.toLocaleString()} / ${max.toLocaleString()}`;
  };

  return (
    <div className="progress-container">
      {label && (
        <div className="progress-label">
          <span>{label}</span>
          <span>{formatDisplay()}</span>
        </div>
      )}
      <div className="progress-bar">
        <div
          className={`progress-fill ${getBarClass()}`}
          style={{ width: isUnlimited ? '0%' : `${percentage}%` }}
        />
      </div>
      {showPercentage && !isUnlimited && (
        <div className="progress-percentage">{percentage.toFixed(1)}%</div>
      )}
    </div>
  );
};

export default ProgressBar;
